import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Diagnostic } from "@ionic-native/diagnostic";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface CameraPermissionBottomSheetProps {
  modalState: UseModalState;
  onCancel: () => void;
  onContinue: () => void;
}

export function CameraPermissionBottomSheet(props: CameraPermissionBottomSheetProps) {
  const { modalState, onCancel, onContinue } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={onCancel}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={async () => {
              if (isCapacitorPlatform()) {
                await Diagnostic.switchToSettings();
              }

              onContinue();
            }}
          >
            Open settings
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="mobile-phone"
        title="Camera access needed"
        description="We can't proceed without camera and microphone access. Please enable both settings in your device settings for the Clipboard Health app to continue."
      />
    </BottomSheet>
  );
}
